export default {"src":"/_next/static/media/garden.2bf1c724.svg","height":33,"width":28,"blurWidth":0,"blurHeight":0};